import React from 'react';
import PropTypes from 'prop-types';
import NavigationLink from './components/NavigationLink';
import structure from '../../structure';

const Navigation = ({ navigation }) => (
  <div className="sidebar">
    <div className="sidebar-nav">
      <nav className='nav'>
        {navigation.map(link => (
          <NavigationLink key={link.path} link={link} />
        ))}
      </nav>
    </div>
  </div>
);

Navigation.propTypes = {
  navigation: PropTypes.array
};

Navigation.defaultProps = {
  navigation: structure.routes.filter(route => route.inMenu)
};

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation/component.js